(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["header"]) return;
  try {
    
  class HeaderWrapper extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.shopify-section-header');

      this.exitTimer = null;
      this.onEnterHandler = this.onEnter.bind(this);
      this.onLeaveHandler = this.onLeave.bind(this);
      this.addEventListener('mouseenter', this.onEnterHandler);
      this.addEventListener('mouseleave', this.onLeaveHandler);
    }

    disconnectedCallback() {
      this.removeEventListener('mouseenter', this.onEnterHandler);
      this.removeEventListener('mouseleave', this.onLeaveHandler);
    }

    onEnter() {
      this.preventClose = true;
      this.header.classList.add('is-active');
      clearTimeout(this.exitTimer);
    }

    onLeave() {
      this.exitTimer = setTimeout(() => {
        this.header.classList.remove('is-active');
      }, 400);
    }

  }
  customElements.define('header-wrapper', HeaderWrapper);

  class StickyHeader extends HeaderWrapper {
    constructor() {
      super();
    }

    connectedCallback() {
      super.connectedCallback();

      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.scrollUpActive = false;
      this.isAtTop = false;

      this.suppressScrollUntil = 0;
      this.toggleBtn = this.querySelector('header-menu-toggle');
      this.toggleBtn?.addEventListener('click', () => {
        this.suppressScrollUntil = performance.now() + 250;
        this.header.classList.toggle('shopify-section-header-menu-open');
      });

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      window.addEventListener('scroll', this.onScrollHandler, false);
      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      this.createObserver();
    }

    disconnectedCallback() {
      super.disconnectedCallback?.();

      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;

        if (this.headerBounds.top === 0 && this.headerBounds.bottom === 0) {
          const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
          const boundingClientRect = entries[0].boundingClientRect;

          this.headerBounds = {
            top: scrollTop + boundingClientRect.top,
            bottom: scrollTop + boundingClientRect.bottom
          };
        }

        if (this.dataset.scrollUp !== undefined) {
          this.scrollUpActive = true;
        }

        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      if (performance.now() < this.suppressScrollUntil) {
        this.currentScrollTop = window.pageYOffset || document.documentElement.scrollTop;
        return;
      }

      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;
      if (scrollTop <= 0) {
        this.header.classList.remove('shopify-section-header-sticky');
        document.body.classList.remove('shopify-body-section-header-sticky');
        this.isAtTop = true;
        this.currentScrollTop = scrollTop;
        return;
      }
      if (this.isAtTop && scrollTop > 10) {
        this.isAtTop = false;
      }
      if (this.isAtTop) {
        this.currentScrollTop = scrollTop;
        return;
      }

      if (theme.config.mqlSmall || this.scrollUpActive) {
        if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          requestAnimationFrame(this.hide.bind(this));
        }
        else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
          if (!this.preventReveal) {
            requestAnimationFrame(this.reveal.bind(this));
          }
          else {
            window.clearTimeout(this.isScrolling);

            this.isScrolling = setTimeout(() => {
              this.preventReveal = false;
            }, 66);

            requestAnimationFrame(this.hide.bind(this));
          }
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }
      else {
        if (scrollTop > this.headerBounds.bottom) {
          if (this.sticky()) return;
          
          requestAnimationFrame(this.hide.bind(this));

          setTimeout(() => {
            requestAnimationFrame(this.reveal.bind(this));
          }, 300);
        }
        else if (scrollTop <= this.headerBounds.top) {
          requestAnimationFrame(this.reset.bind(this));
        }
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      document.body.classList.add('shopify-body-section-header-hidden', 'shopify-body-section-header-sticky');
    }

    reveal() {
      if (this.isAtTop) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
      document.body.classList.add('shopify-body-section-header-sticky');
      document.body.classList.remove('shopify-body-section-header-hidden');
    }

    reset() {
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    sticky() {
      return this.header.classList.contains('shopify-section-header-sticky') && !this.header.classList.contains('shopify-section-header-hidden') && document.body.classList.contains('shopify-body-section-header-sticky') && !document.body.classList.contains('shopify-body-section-header-hidden');
    }
  }
  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpcc-bf-standard-offers"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tpcc-bf-offers')) {
    customElements.define('tpcc-bf-offers', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.querySelectorAll('[data-bf-cream]').forEach((button) => {
          button.addEventListener('click', () => {
            const feature = button.closest('.bf-feature');
            feature.querySelectorAll('[data-bf-cream]').forEach((choice) => {
              choice.setAttribute('aria-pressed', String(choice === button));
            });
            feature.querySelectorAll('[data-bf-cream-panel]').forEach((panel) => {
              panel.hidden = panel.dataset.bfCreamPanel !== button.dataset.bfCream;
            });
          }, { signal: this.events.signal });
        });
        this.dismissedMarketingForms = new WeakSet();
        const dismissMarketingPopup = () => {
          const buttons = [document.querySelector('[id^="alia-root-"][aria-label="Promotional popup"] button[aria-label="Close popup"]')];
          if (document.body.classList.contains('klaviyo-prevent-body-scrolling')) buttons.push(document.querySelector('button.klaviyo-close-form'));
          buttons.forEach((closeButton) => {
            if (!closeButton || this.dismissedMarketingForms.has(closeButton)) return;
            this.dismissedMarketingForms.add(closeButton);
            closeButton.click();
          });
        };
        this.marketingObserver = new MutationObserver(dismissMarketingPopup);
        this.marketingObserver.observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
        dismissMarketingPopup();
        const options = { signal: this.events.signal };
        const mainCTA = document.querySelector('[data-offer-main-cta]');
        mainCTA?.addEventListener('click', (event) => {
          const href = event.currentTarget.getAttribute('href');
          if (!href?.startsWith('#')) return;
          const target = document.getElementById(href.slice(1));
          if (target?.tagName === 'DETAILS') target.open = true;
        }, options);
        if (this.dataset.exitEnabled !== 'true' || this.dataset.campaign !== 'black-friday-2026' || window.Shopify?.designMode) return;
        const dialog = this.querySelector('dialog');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        const key = `tpcc-bf-exit:${location.hostname}:${this.dataset.campaign}`;
        let activeTime = 0;
        let activeStartedAt = document.visibilityState === 'visible' && document.hasFocus() ? performance.now() : null;
        let pointerInside = false;
        let previousPointer;
        let lastPointer;
        let scrollIntent = false;
        let engaged = false;
        let shown = false;
        let previousFocus;
        let nextFocusTarget;
        try { shown = sessionStorage.getItem(key) === 'shown'; } catch (_) {}
        const remember = () => {
          shown = true;
          try { sessionStorage.setItem(key, 'shown'); } catch (_) {}
        };
        const resetPointer = () => {
          pointerInside = false;
          previousPointer = null;
          lastPointer = null;
          scrollIntent = false;
        };
        const pauseVisit = () => {
          if (activeStartedAt !== null) activeTime += performance.now() - activeStartedAt;
          activeStartedAt = null;
          resetPointer();
        };
        const resumeVisit = () => {
          resetPointer();
          if (document.visibilityState === 'visible' && document.hasFocus() && activeStartedAt === null) activeStartedAt = performance.now();
        };
        const updateEngagement = () => {
          if (!scrollIntent) return;
          const mainCTA = document.querySelector('[data-offer-main-cta]');
          if (mainCTA && mainCTA.getBoundingClientRect().bottom < 0) engaged = true;
        };
        const blockedByUI = () => {
          if (document.body.classList.contains('mini-cart--open') || document.body.classList.contains('mini-cart--opening')) return true;
          const active = document.activeElement;
          if (active?.matches('input, textarea, select, [role="textbox"]') || active?.isContentEditable) return true;
          return Array.from(document.querySelectorAll('dialog[open], cart-drawer details[open], menu-drawer details[open], modal-dialog[open], [aria-modal="true"]')).some((overlay) => {
            return overlay.getAttribute('aria-hidden') !== 'true' && overlay.getClientRects().length > 0;
          });
        };
        window.addEventListener('blur', pauseVisit, options);
        window.addEventListener('focus', resumeVisit, options);
        window.addEventListener('pageshow', resetPointer, options);
        document.addEventListener('visibilitychange', () => {
          if (document.visibilityState === 'visible') resumeVisit();
          else pauseVisit();
        }, options);
        document.addEventListener('pointermove', (event) => {
          if (!event.isTrusted || event.pointerType !== 'mouse' || document.visibilityState !== 'visible' || !document.hasFocus()) return;
          if (event.clientX <= 0 || event.clientX >= window.innerWidth || event.clientY <= 0 || event.clientY >= window.innerHeight) return;
          if (event.clientY >= 64) pointerInside = true;
          previousPointer = lastPointer;
          lastPointer = { x: event.clientX, y: event.clientY, at: performance.now() };
        }, { ...options, passive: true });
        document.addEventListener('wheel', (event) => { if (event.isTrusted) scrollIntent = true; }, { ...options, passive: true });
        document.addEventListener('pointerdown', (event) => { if (event.isTrusted) scrollIntent = true; }, { ...options, passive: true });
        document.addEventListener('keydown', (event) => {
          if (event.isTrusted && ['ArrowDown', 'ArrowUp', 'PageDown', 'PageUp', 'Home', 'End', ' '].includes(event.key)) scrollIntent = true;
        }, options);
        document.addEventListener('scroll', updateEngagement, { ...options, passive: true });
        const offerDetails = [...this.querySelectorAll('.bf-feature__details'), ...document.querySelectorAll('.offer-showcase--bf-journey details')];
        offerDetails.forEach((details) => {
          details.querySelector('summary')?.addEventListener('click', (event) => { if (event.isTrusted) engaged = true; }, options);
        });
        mainCTA?.addEventListener('click', (event) => {
          if (event.isTrusted) engaged = true;
        }, options);
        this.querySelectorAll('[data-bf-close]').forEach((button) => {
          button.addEventListener('click', () => dialog.close(), options);
        });
        dialog.querySelector('[data-bf-view-offer]')?.addEventListener('click', (event) => {
          const target = document.getElementById(event.currentTarget.getAttribute('href').slice(1));
          if (!target) return;
          event.preventDefault();
          const details = target.querySelector('.bf-feature__details');
          if (details) details.open = true;
          target.setAttribute('tabindex', '-1');
          nextFocusTarget = target;
          dialog.close();
        }, options);
        dialog.addEventListener('cancel', (event) => {
          event.preventDefault();
          dialog.close();
        }, options);
        dialog.addEventListener('click', (event) => {
          if (event.target !== dialog) return;
          const bounds = dialog.getBoundingClientRect();
          if (event.clientX < bounds.left || event.clientX > bounds.right || event.clientY < bounds.top || event.clientY > bounds.bottom) dialog.close();
        }, options);
        dialog.addEventListener('close', () => {
          remember();
          const destination = nextFocusTarget;
          const focusTarget = destination || previousFocus;
          nextFocusTarget = null;
          requestAnimationFrame(() => {
            if (!focusTarget?.isConnected) return;
            focusTarget.focus({ preventScroll: true });
            if (destination) destination.scrollIntoView({ block: 'start', behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'auto' : 'smooth' });
          });
        }, options);
        document.addEventListener('mouseout', (event) => {
          if (!event.isTrusted || shown || event.relatedTarget || event.clientY > 0 || document.visibilityState !== 'visible' || !document.hasFocus()) return;
          updateEngagement();
          const now = performance.now();
          const dwell = activeTime + (activeStartedAt === null ? 0 : now - activeStartedAt);
          const upwardDeparture = pointerInside && previousPointer && lastPointer && lastPointer.y <= 120 && previousPointer.y - lastPointer.y >= 8 && now - lastPointer.at <= 1500;
          if (dwell < 15000 || !engaged || !upwardDeparture) return;
          if (!matchMedia('(hover: hover) and (pointer: fine)').matches || blockedByUI()) return;
          previousFocus = document.activeElement;
          nextFocusTarget = null;
          dialog.showModal();
          remember();
        }, options);
      }
      disconnectedCallback() {
        this.events?.abort();
        this.marketingObserver?.disconnect();
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["tpcc-black-friday"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('tpcc-bf-offers')) {
    customElements.define('tpcc-bf-offers', class extends HTMLElement {
      connectedCallback() {
        if (this.events) return;
        this.events = new AbortController();
        this.dismissedMarketingForms = new WeakSet();
        const dismissMarketingPopup = () => {
          const buttons = [document.querySelector('[id^="alia-root-"][aria-label="Promotional popup"] button[aria-label="Close popup"]')];
          if (document.body.classList.contains('klaviyo-prevent-body-scrolling')) buttons.push(document.querySelector('button.klaviyo-close-form'));
          buttons.forEach((closeButton) => {
            if (!closeButton || this.dismissedMarketingForms.has(closeButton)) return;
            this.dismissedMarketingForms.add(closeButton);
            closeButton.click();
          });
        };
        this.marketingObserver = new MutationObserver(dismissMarketingPopup);
        this.marketingObserver.observe(document.body, { attributes: true, attributeFilter: ['class'], childList: true, subtree: true });
        dismissMarketingPopup();
        if (this.dataset.exitEnabled !== 'true' || window.Shopify?.designMode) return;
        const dialog = this.querySelector('dialog');
        if (!dialog || typeof dialog.showModal !== 'function') return;
        const options = { signal: this.events.signal };
        const key = `tpcc-bf-exit:${location.hostname}:${this.dataset.campaign}`;
        let shown = false;
        try { shown = sessionStorage.getItem(key) === 'shown'; } catch (_) { /* Suppress in memory when storage is unavailable. */ }
        const remember = () => {
          shown = true;
          try { sessionStorage.setItem(key, 'shown'); } catch (_) { /* Keep the in-memory guard. */ }
        };
        this.querySelectorAll('[data-bf-close]').forEach((button) => {
          button.addEventListener('click', () => dialog.close(), options);
        });
        dialog.addEventListener('close', remember, options);
        document.addEventListener('mouseout', (event) => {
          if (shown || event.relatedTarget || event.clientY > 0 || document.visibilityState !== 'visible') return;
          if (!matchMedia('(hover: hover) and (pointer: fine)').matches || document.querySelector('dialog[open]')) return;
          dialog.showModal();
          remember();
        }, options);
      }
      disconnectedCallback() {
        this.events?.abort();
        this.marketingObserver?.disconnect();
        this.events = null;
      }
    });
  }

  } catch(e) { console.error(e); }
})();
})();
